import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { SharedHttpClient } from '@luggagehero/shared/services/http';
import { catchError, map, Observable, of } from 'rxjs';

export interface VatNumberInfo {
  vatNumber: string;
  countryCode: string;
  name: string;
}

export enum VatNumberLookupStatus {
  Valid = 'Valid',
  Invalid = 'Invalid',
  NotFound = 'NotFound',
  Error = 'Error',
}

export interface VatNumberLookupResult {
  status: VatNumberLookupStatus;
  value?: VatNumberInfo;
}

export const VAT_NUMBER_SERVICE_ENDPOINT_TOKEN = new InjectionToken<string>('VAT_NUMBER_SERVICE_ENDPOINT_TOKEN');
@Injectable({
  providedIn: 'root',
})
export class SharedVatNumberService {
  private http = inject(SharedHttpClient);

  private readonly apiEndPoint = inject(VAT_NUMBER_SERVICE_ENDPOINT_TOKEN);

  public lookUpVatNumber(vatNumber: string, countryCode: string): Observable<VatNumberLookupResult> {
    // Validate input
    countryCode = countryCode.trim().toUpperCase().replace('GR', 'EL'); // Convert 'GR' to 'EL' for Greece
    vatNumber = vatNumber.trim();

    const url = `${this.apiEndPoint}/vat_numbers/${vatNumber}?countryCode=${countryCode}`;

    return this.http.get<VatNumberInfo>(url).pipe(
      map((value) => ({ status: VatNumberLookupStatus.Valid, value })),
      catchError((error) => {
        let status = VatNumberLookupStatus.Error;

        if (error instanceof HttpErrorResponse) {
          switch (error.status as HttpStatusCode) {
            case HttpStatusCode.BadRequest:
              status = VatNumberLookupStatus.Invalid;
              break;

            case HttpStatusCode.NotFound:
              status = VatNumberLookupStatus.NotFound;
              break;

            case HttpStatusCode.InternalServerError:
            default:
              status = VatNumberLookupStatus.Error;
              break;
          }
        }

        return of<VatNumberLookupResult>({ status });
      }),
    );
  }
}
